// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"193":"12290f5b","861":"58c2413a","880":"444b34c9"}[chunkId] + ".chunk.css";
};